<template>
   <div class="adminPage">
      <div class="titlePage">
         Administración - Porcentajes de Evaluación
      </div>
      <!-- NOTIFICACIONES -->
      <va-notification color="info" v-if="addRExito" class="refNoData">
         Se creó correctamente el porcentaje solicitado.
      </va-notification>
      <va-notification color="info" v-if="UpdRExito" class="refNoData">
         Se actualizó correctamente el porcentaje solicitado.
      </va-notification>
      <va-notification color="danger" v-if="refNoUpdate" class="refNoData">
         La actualización presentó un fallo.
      </va-notification>
      <va-notification color="danger" v-if="refWSUpdate" class="refNoData">
         El servicio de actualización no está disponible.
      </va-notification>
      <va-notification color="danger" v-if="porcentaje" class="refNoData">
         El porcentaje no debe ser mayor a 100.
      </va-notification>
      <va-notification color="danger" v-if="existFlag" class="refNoData">
         Este porcentaje ya existe.
      </va-notification>
      <!-- BUSCADOR -->
      <div class="adminCard">
         <div class="adminCardBody">
            <ValidationObserver ref="obsFieldsSearch">
               <FormSearch
                  :FieldsForm="formSearch"
                  :ModelForm="formSchModel"
                  :method="executeProcess"
                  />
            </ValidationObserver>
         </div>
      </div>
      <va-notification
         color="danger"
         id="refNoData"
         class="refNoData noShow"
         >
         No se encontró información del porcentaje solicitado.
      </va-notification>
      <!-- TABLA -->
      <div class="adminCard">
         <div class="adminCardBody listPrograms">
            <DataTable
               :InfoView="DLPorcentaje"
               :HeadTable="HDPorcentaje"
               :method="processData"
               v-if="renderComponent1"
               />
         </div>
      </div>
      <modal
   name="percentModal"
   width="80%"
   height="auto"
   :scrollable="true"
   :adaptive="true"
   :clickToClose="false"
>
   <div class="modalContainer">

      <div class="titlePage">
         Administración - Porcentajes de Evaluación
      </div>

      <div class="tabcontent">

         <ValidationObserver ref="obsFieldsUpdate">
            <Formupdate
               :FieldsForm="formUpdate"
               :ModelForm="formUpdModel"
               :method="executeProcess"
               v-if="renderComponent2"
            />
         </ValidationObserver>

         <div class="modalActions">

            <div style="flex:1">
               <va-notification
                  color="danger"
                  v-if="refValidator"
                  class="refNoData"
               >
                  {{ AlertValidator }}
               </va-notification>
            </div>

            <button
               v-if="isNew === false"
               id="updatePercent"
               class="loginbtn primaryBtn"
               @click="updatePercent"
            >
               Actualizar
            </button>

            <button
               v-if="isNew === true"
               id="AddPercent"
               class="loginbtn primaryBtn"
               @click="AddPercent"
            >
               Guardar
            </button>

            <button
               id="CancelPercent"
               class="loginbtn secondaryBtn"
               @click="CancelUser"
            >
               Cancelar
            </button>

         </div>

      </div>

   </div>
</modal>
   </div>
</template>
<script>
// eslint-disable-next-line import/no-duplicates
import FormSearch from '@/components/forms/Forms.vue'
import Formupdate from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import IberoHelpers from '@/store/helpers.js'
// Data Table.
import DataTable from '@/components/data-tables/DataEvalPercent.vue'

export default {
    name: 'dataUpdate',
    components: {
        FormSearch,
        Formupdate,
        DataTable,
    },
    data() {
        return {
            EvalRolList: IberoHelpers.GetEvalRolesSelect(this.$store),
            formSchModel: {},
            formSearch: [
                {
                    id: 'Sch_Button',
                    type: 'button',
                    placeholder: 'Consultar Porcentaje',
                    class: 'botonReff',
                },
                {
                    id: 'Sch_ButtonNew',
                    type: 'button',
                    placeholder: 'Crear Porcentaje',
                    class: '',
                },
            ],
            formUpdModel: {
                id: '',
                idEvalRol: '',
                percentEval: '',
                status: '',
            },
            

            formUpdate: [
                {
                    id: 'idEvalRol',
                    model: 'idEvalRol',
                    name: 'Rol',
                    type: 'Select',
                    placeholder: 'Seleccione...',
                    values: this.$store.state.EvalRolList,
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },
                {
                    id: 'percentEval',
                    model: 'percentEval',
                    name: 'Porcentaje',
                    type: 'input',
                    attributes: '',
                    placeholder: 'Porcentaje',
                    validate: {
                        required: true,
                        regex: /^(\d+)?(?:\.\d+)?$/,
                    },
                    class: 'col-md-4',
                },
                {
                    id: 'status',
                    model: 'status',
                    name: 'Estado',
                    type: 'Select',
                    placeholder: 'Seleccione un estado',
                    values: [
                        { id: 'Activo', value: 'Activo' },
                        { id: 'Inactivo', value: 'Inactivo' },
                    ],
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },
            ],

            HDPorcentaje: [
                {
                    name: 'id',
                    title: 'Id',
                    sortField: 'id',
                    width: '7%',
                },
                {
                    name: 'tipoEval',
                    title: 'tipo de formulario',
                    sortField: 'tipoEval'
                },
                {
                    name: 'rol',
                    title: 'rol',
                    sortField: 'rol',
                    with: '25%'
                },
                {
                    name: 'percentEval',
                    title: 'Porcentaje',
                    sortField: 'percentEval',
                    width: '20%',
                },
                {
                    name: 'status',
                    title: 'Estado',
                    sortField: 'status',
                    width: '30%',
                },
                {
                    name: '__slot:actions',
                    title: 'Acciones',
                    dataClass: 'text-center',
                    actionRef: [
                        {
                            label: 'Editar',
                            icon: 'fa-pencil',
                            action: 'edit',
                        },
                    ],
                },

            ],
            DLPorcentaje: [],
            renderComponent1: false,
            renderComponent2: false,
            addRExito: false,
            UpdRExito: false,
            refNoUpdate: false,
            refWSUpdate: false,
            existFlag: false,
            porcentaje: false,
            isNew: false,
        }
    },

    methods: {

        openModal() {
            this.$modal.show('percentModal')
        },
        closeModal() {
            this.$modal.hide('percentModal')
        },
        executeProcess: function (event, refer) {
            this.limpiaref()
            switch (event.target.id) {
                case 'btn_Sch_Button':
                    this.isNew = false
                    return new Promise((resolve, reject) => {
                        this.$refs.obsFieldsSearch.validate().then(results => {
                            if (!results) {
                                resolve(false)
                            } else {
                                this.searchForm()
                                resolve(true)
                            }
                        })
                    })
                case 'btn_Sch_ButtonNew':
                    this.limpiaref()
                    this.clearFields()
                    this.isNew = true
                    IberoHelpers.forceRerender2(this)
                    this.$modal.show('percentModal')
            }
            this.$refs.obsFieldsSearch.validate()
        },

        hideCard(card) {
            switch (card) {
                case 'creado':
                    setTimeout(() => {
                        this.addRExito = false
                    }, 5000);
                    break;
                case 'actualizado':
                    setTimeout(() => {
                        this.UpdRExito = false
                    }, 5000);
                    break;
                case 'actFallo':
                    setTimeout(() => {
                        this.refNoUpdate = false
                    }, 5000);
                    break;
                case 'noActivo':
                    setTimeout(() => {
                        this.refWSUpdate = false
                    }, 5000);
                case 'mas100':
                    setTimeout(() => {
                        this.porcentaje = false
                    }, 5000);

                    break;
            }
        },

        async checkData(rol) {

            let existflag = false;
            this.existFlag = false;

            const { data } = await IberoHelpers.GetEvalPercent(this.$store, this.formSchModel, 0)

            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    console.log(data[i].idEvalRol)
                    if (data[i].idEvalRol == rol) {
                        existflag = true
                        break;
                    }
                }
            }
            return existflag
        },

        searchForm() {
            document.getElementById('refNoData').classList.add('noShow')
            this.isNew = false
            let loader = this.$loading.show()
            var listPorcentaje = IberoHelpers.GetEvalPercent(this.$store, this.formSchModel, 0)
            this.renderComponent1 = false
            listPorcentaje.then(Response => {
                if ((Response.data === undefined) || (Response.data === '')) {
                    document.getElementById('refNoData').classList.remove('noShow')
                } else {
                    if (Array.isArray(Response.data)) {
                        for (let i = 0; i < Response.data.length; i++) {
                            if (Response.data[i].status === true) {
                                Response.data[i].status = 'Activo'
                            } if (Response.data[i].status === false) {
                                Response.data[i].status = 'Inactivo'
                            }
                        }
                        this.DLPorcentaje = Response.data
                    } else {
                        for (let i = 0; i < Response.data.length; i++) {
                            if ([Response.data[i]].status === true) {
                                [Response.data[i]].status = 'Activo'
                            } else if ([Response.data[i]].status === false) {
                                [Response.data[i]].status = 'Inactivo'
                            }
                        }
                        this.DLPorcentaje = [Response.data]
                    }
                    IberoHelpers.forceRerender1(this)
                }
                loader.hide()
            })
        },

        async updatePercent() {
            if (this.formUpdModel.percentEval <= 100) {
                return new Promise((resolve, reject) => {
                    this.$refs.obsFieldsUpdate.validate().then(results => {
                        if (!results) {
                            resolve(false)
                        } else {
                            let loader = this.$loading.show()
                            var totalinf = IberoHelpers.EditEvalPercent(
                                this.$store,
                                this.formUpdModel
                            )
                            totalinf.then(Response => {
                                this.renderComponent1 = false
                                if (Response === false) {
                                    this.refWSUpdate = true
                                    this.hideCard('noActivo')
                                    resolve(false)
                                } else if (!(Response.status === 200)) {
                                    this.refNoUpdate = true
                                    this.hideCard('actFallo')
                                    resolve(false)
                                } else if (Response.status === 200){
                                    this.UpdRExito = true
                                    this.hideCard('actualizado')
                                    resolve(true)
                                }
                                this.$modal.hide('percentModal')
                                this.searchForm()
                                loader.hide()
                            })

                        }
                    })
                })
            } else if (this.formUpdModel.percentEval > 100) {
                this.$modal.hide('percentModal')
                this.porcentaje = true
                this.hideCard('mas100')
                this.searchForm()
            }
        },

        async AddPercent() {
            this.limpiaref()
            let ExistRol;
            ExistRol = await this.checkData(
                this.formUpdModel.idEvalRol
            )
            console.log(ExistRol)

            if (ExistRol == false && this.formUpdModel.percentEval <= 100) {
                return new Promise((resolve, reject) => {
                    this.$refs.obsFieldsUpdate.validate().then(results => {
                        if (!results) {
                            resolve(false)
                        } else {
                            let loader = this.$loading.show()
                            var totalinf = IberoHelpers.AddEvalPercent(this.$store, this.formUpdModel)
                            totalinf.then(Response => {
                                this.renderComponent1 = false
                                if (Response === false) {
                                    this.refWSUpdate = true
                                    resolve(false)
                                } else if (!(Response.status === 200)) {
                                    this.refNoUpdate = true
                                    resolve(false)
                                } else if (ExistRol == false) {
                                    this.addRExito = true
                                    this.hideCard('creado')
                                }
                                this.$modal.hide('percentModal')
                                this.searchForm()
                                loader.hide()
                            })
                        }
                    })
                })
            } else if (this.formUpdModel.percentEval > 100) {
                this.$modal.hide('percentModal')
                this.porcentaje = true
                this.hideCard('mas100')
                this.searchForm()
            } else {
                this.$modal.hide('percentModal')
                this.existFlag = true
                this.hideCard('existe')
                this.searchForm()
            }
        },

        CancelUser() {
            this.limpiaref()
            this.clearFields()
            this.$modal.hide('percentModal')
        },

        limpiaref() {
            this.addRExito = false
            this.UpdRExito = false
            this.refNoUpdate = false
            this.refWSUpdate = false
            document.getElementById('refNoData').classList.add('noShow')
        },
        clearFields() {
            this.formUpdModel.id = ''
            this.formUpdModel.idEvalRol = ''
            this.formUpdModel.percentEval = ''
            this.formUpdModel.status = ''
        },

        changeInput() {
            let input = document.getElementById('percentEval')

            console.log(input)
        },

        processData: function (dataInf, refdata) {
            this.limpiaref()
            this.isNew = false
            this.formUpdModel.id = dataInf.id
            this.formUpdModel.idEvalRol = dataInf.idEvalRol
            this.formUpdModel.percentEval = dataInf.percentEval
            this.formUpdModel.status = dataInf.status
            IberoHelpers.forceRerender2(this)
            this.$modal.show('percentModal')
        },

    },
    mounted() {

        this.changeInput()

        this.searchForm()

    },
}
</script>